import api from "@/lib/api";

// Chunked upload: init → PUT chunks → complete. onProgress(0..1)
export async function uploadMarketFile(listingId, file, onProgress) {
  const { data: init } = await api.post("/market/uploads/init", {
    listing_id: listingId,
    filename: file.name,
    content_type: file.type || "application/octet-stream",
    size: file.size,
  });
  const { upload_id: uploadId, chunk_size: chunkSize } = init;
  let offset = 0;
  while (offset < file.size) {
    const blob = file.slice(offset, offset + chunkSize);
    await api.put(`/market/uploads/${uploadId}/chunk`, blob, {
      headers: { "Content-Type": "application/octet-stream" },
      timeout: 120000,
    });
    offset += blob.size;
    onProgress?.(Math.min(offset / file.size, 0.98));
  }
  const { data } = await api.post(`/market/uploads/${uploadId}/complete`, null, { timeout: 300000 });
  onProgress?.(1);
  return data;
}

export const SPECIES = ["canary", "budgie", "lovebird", "cockatiel", "zebra_finch", "parrot", "other"];
export const MAX_IMAGES = 6;
export const MAX_IMAGE_MB = 10;
export const MAX_VIDEO_MB = 100;
